import React, { createContext, useContext, useEffect, useState } from 'react';
import { BreadcrumbLink, TitleContextType } from "../types";

const TitleContext = createContext<TitleContextType>({} as TitleContextType);
const useTitle = () => useContext(TitleContext);

function TitleProvider(props: React.PropsWithChildren<unknown>) {
    const [title, setTitle] = useState('');
    const [dynamicLinks, setDynamicLinks] = useState([] as BreadcrumbLink[]);

    useEffect(() => {
        document.title = title ? (title + " - Sage Sync") : "Sage Sync";
    }, [title]);

    return (
        <TitleContext.Provider
            value={{ title, setTitle, dynamicLinks, setDynamicLinks }}
            {...props}
        />
    );
}

export { TitleProvider, useTitle }
